import Vue from "vue";
import Vuex from "vuex";
import config from "./config";
import constant from "./constant";
import api from "@/store/modules/api";
import auth from "@/store/modules/auth";
import home from "@/store/modules/home";
import user from "@/store/modules/user";
import company from "@/store/modules/company";
import department from "@/store/modules/department";
import position from "@/store/modules/position";
import car from "@/store/modules/car";
import phrase from "@/store/modules/phrase";
import holiday from "@/store/modules/holiday";
import rankHistory from "@/store/modules/rank-history";
import accidentHistory from "@/store/modules/accident-history";
import departmentHistory from "@/store/modules/department-history";
import positionHistory from "@/store/modules/position-history";
import forceUpdateHistory from "@/store/modules/force-update-history";
import companyNotice from "@/store/modules/company-notice";
import approval from "@/store/modules/approval";
import approvalAttendance from "@/store/modules/approval-attendance";
import approvalLeave from "@/store/modules/approval-leave";
import approvalOvertime from "@/store/modules/approval-overtime";
import attendance from "@/store/modules/attendance";
import site from "@/store/modules/site";
import notice from "@/store/modules/notice";
import csv from "@/store/modules/csv";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    config: config,
    constant: constant
  },
  mutations: {},
  actions: {},
  modules: {
    api: api,
    auth: auth,
    home: home,
    user: user,
    company: company,
    department: department,
    position: position,
    car: car,
    phrase: phrase,
    holiday: holiday,
    rankHistory: rankHistory,
    accidentHistory: accidentHistory,
    departmentHistory: departmentHistory,
    positionHistory: positionHistory,
    forceUpdateHistory: forceUpdateHistory,
    companyNotice: companyNotice,
    approval: approval,
    approvalAttendance: approvalAttendance,
    approvalLeave: approvalLeave,
    approvalOvertime: approvalOvertime,
    attendance: attendance,
    site: site,
    notice: notice,
    csv: csv
  }
});
